import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'font-(family-name:--font-geist)',
    navigation:
      'fixed right-0 bottom-2 left-0 z-10 mx-auto transition-transform duration-500 ease-out md:flex md:justify-center lg:top-[710px] lg:bottom-auto'
  },
  variants: {
    isScrolled: {
      true: {
        navigation: 'lg:translate-y-[calc(100vh-710px-70px)]'
      },
      false: {
        navigation: 'lg:translate-y-0'
      }
    },
    isNearFooter: {
      true: {
        navigation: 'pointer-events-none opacity-0'
      },
      false: {
        navigation: 'opacity-100'
      }
    }
  }
});
